import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Order from './components/Order';
import MenuSelect from './components/MenuChoice/MenuSelect';
import Cart from './components/Cart/Cart';
import OrderList from './components/OrderList/OrderList';
import MenuChange from './components/MenuChange/MenuChange';
import Cancel from './components/Cancel/Cancel';
import CantUse from './components/CantUse/CantUse';
import End from './components/End/End';
import ScrollToTop from './components/ScrollTop/ScrollToTop';
import OrderListDetail from './components/OrderList/OrderListDetail';
import CallDetail from './components/CallService/CallCompo/CallDetail';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/:id" element={<Order />} />
          <Route path="/calldetail" element={<CallDetail />} />
        <Route path="/menu" element={<MenuSelect />} />
        <Route path="/orderlist" element={<OrderList />} />
          <Route path="/orderlistdetail" element={<OrderListDetail />} />

        {/* <Route path="/cart" element={<Cart />} /> */}
        <Route path="/cart/:secureId" element={<Cart />} />
        <Route path="/Cancel" element={<Cancel />} />
        <Route path="/menuchange" element={<MenuChange />} />
        <Route path="/CantUse" element={<CantUse />} />
        <Route path="/End" element={<End />} />
        <Route path="/" element={<Order />} />
      </Routes>
    </>  
  );
}

export default App;
